import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import MDBox from "common/components/MDBox";
import image1 from "assets/images/studentTwo.png"
import image2 from "assets/images/scholarship.png";
import image3 from "assets/images/studentOne.png";
import image4 from "assets/images/graduation.png"
import "./style.css"
import DashBoardCards from "common/components/DashBoardCards";
import { useDispatch, useSelector } from "react-redux";
import { getStudentCount } from "services/student/student";
import {
    ResponsiveContainer,
    BarChart,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    Bar,
} from "recharts";
import { chartDetails } from "services/student/student";

function Dashboard() {

    const dispatch = useDispatch()
    const count = useSelector(state => state.studentCountSlice.count);
    const chartDitail = useSelector(state => state.chartDetailsSlice.chart);
    const [courseCount, setCourseCount] = useState(0)
    const [studentCount, setStudentCount] = useState(0)
    const [chartData, setChartData] = useState([])
    const [completeStudentCount, setCompleteStudentCount] = useState(0)
    const [lectures, setLectures] = useState(0)
    const data = [
        {
            image: image4,
            title: "Student",
            noOfStudents: studentCount,
            bgColourmain: "#253BFF",
            bgColourSec: "#ABB3FF"
        },
        {
            image: image2,
            title: "Complete Student",
            noOfStudents: completeStudentCount,
            bgColourmain: "#FFC146",
            bgColourSec: "#FFE1A6"
        },
        {
            image: image3,
            title: "Employees",
            noOfStudents: lectures,
            bgColourmain: "#F55254",
            bgColourSec: "#FF9E9F"
        }
        , {
            image: image1,
            title: "Course",
            noOfStudents: courseCount,
            bgColourmain: "#4D4E8D",
            bgColourSec: "#A6A7E5"
        }
    ];

    useEffect(() => {
        dispatch(getStudentCount());
        dispatch(chartDetails())
    }, []);


    useEffect(() => {
        if (count.isSuccess) {
            const data = count.data
            setStudentCount(data.students)
            setCourseCount(data.courses)
            setCompleteStudentCount(data.completed_students)
            setLectures(data.employees)
        }
    }, [count.data])

    useEffect(()=> {
        if(chartDitail.isSuccess) {
            const data = [];
            chartDitail.data?.forEach(val => {
                data.push({ name: val.month.substring(0, 3), count: val.count },)
            });
            setChartData(data)
        }
    },[chartDitail.data])

    return (
        <MDBox pt={3} pb={3}>
            <Grid container gap={0}>
                {data.map((item, index) => (
                    <DashBoardCards item={item} key={index} />
                ))}
            </Grid>

            <MDBox mt={4} sx={{ backgroundColor: "#FFF", borderRadius: "15px", p: 2 }}>
                <h3 style={{ margin: 0, marginBottom: 12 }}>
                    Registrations (Last 6 Months)
                </h3>
                <div style={{ width: "100%", height: 300 }}>
                    <ResponsiveContainer>
                        <BarChart data={chartData}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis allowDecimals={false} />
                            <Tooltip />
                            <Bar dataKey="count" fill="#4D4E8D" />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </MDBox>
        </MDBox>
    );
}

export default Dashboard;
